import type { FC } from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export interface PlanDetailTaskSubtasksProps {
  taskId: string;
  subtaskNames: string[];
}

export const PlanDetailTaskSubtasks: FC<PlanDetailTaskSubtasksProps> = ({
  taskId,
  subtaskNames,
}) => {
  const { t } = useTranslation('maintenance');

  return (
    <div
      className="plan-detail-subtasks"
      data-subtask-count={subtaskNames.length}
    >
      <Flex align="center" gap={8} className="plan-detail-subtasks__header">
        <span className="plan-detail-subtasks__header-icon" aria-hidden>
          <UnorderedListOutlined />
        </span>
        <Text strong className="plan-detail-subtasks__title">
          {t('detail.tasks.subtasksTitle')}
        </Text>
        <Text type="secondary" className="plan-detail-subtasks__count">
          {t('tasks.subtasks.count', { count: subtaskNames.length })}
        </Text>
      </Flex>

      <ol className="plan-detail-subtasks__list">
        {subtaskNames.map((name, index) => (
          <li
            key={`${taskId}-subtask-${index}`}
            className="plan-detail-subtasks__item"
            style={{ animationDelay: `${40 + index * 35}ms` }}
          >
            <span className="plan-detail-subtasks__step" aria-hidden>
              {index + 1}
            </span>
            <Text className="plan-detail-subtasks__name">{name}</Text>
          </li>
        ))}
      </ol>
    </div>
  );
};
